import React, { useContext, useMemo } from 'react';
import { shallowEqual, useSelector } from 'umi';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';

export default function RadarChartCardService(props: any) {
  const { style, className, api, dataKey = 'radarChartData', data: propsData, children, extraParams = {}, isMaxMetrics = false, ...resetProps } = props || {};
  const { gameCode, dataFrame } = useSelector((state: any) => ({
    gameCode: state?.dashboard?.currentGame?.game_code,
    dataFrame: state.dashboard?.currentGame?.data_frame || 'mobile',
  }), shallowEqual);
  const contextObj = useContext(FilterContext);
  const { filterVal = {} } = contextObj || {};

  const data = useMemo(() => ({
    gameCode,
    dataFrame,
    // 多层数据挂载
    ...(propsData || {}),
    ...(extraParams || {})
  }), [gameCode, dataFrame, propsData, extraParams]);

  // 指标最大值接口，指标改变才重新请求
  const metrics = useMemo(() => filterVal?.metrics, [JSON.stringify(filterVal?.metrics)]);
  const changeFilterValue = useMemo(() => ({
    metrics,
  }), [metrics]);

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        dataKey={dataKey}
        trackData={["gameCode", "dataFrame", "extraParams"]}
        {...(isMaxMetrics ? { filterVal: changeFilterValue } : {})}
        beforeRequest={(data) => {
          const { filterVal, gameCode, dataFrame } = data;
          const { metrics, genre_list: genreList, game_list: gameList } = filterVal || {};
          const frameMap: any = {
            pc: 'PC&Console',
            mobile: 'Mobile'
          };
          const params = {
            game_code: gameCode,
            frame_type: frameMap?.[dataFrame || 'pc'],
            metrics,
            genre_list: isMaxMetrics ? undefined : genreList,
            game_list: isMaxMetrics ? undefined : gameList,
            ...extraParams,
          };
          return params;
        }}
      >
        {React.Children.map(children, (child: any) => React.cloneElement(
          child,
          {
            ...resetProps,
            state: {}
          }
        ))}
      </Service>
    </div>
  );
};
